import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { Alert } from "@material-ui/lab";
import React, { Component, Fragment } from "react";
import store from "../redux/store";
import { CLOSE_QUIZ_ABANDON, CLOSE_QUIZ_DONE, OPEN_QUIZ } from "../redux/types";
import {  getSurveyStatus } from "../redux/actions/dataActions";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {};

// LinkToGoogleFormIframe
// Create a link that opens up a MUI dialog box containing an iframe of the quiz

// Usage
/* 
<LinkToGoogleFormIframe title="Quiz" href="https://docs.google.com/forms/d/e/1FAIpQLSdkzGDfKKxWdLJ7mdG-Jni-FpVJjown19XNwnrvSVc3z2DwAQ/viewform">
    Launch form
</LinkToGoogleFormIframe> 
*/

class LinkToGoogleFormIframe extends Component {
  state = { isQuizBoxOpen: false, isAlertBoxOpen: false };

  render() {
    const closeQuizBox = () => {
      this.setState({ isAlertBoxOpen: true });
    };

    const closeAlertBox = () => {
      this.setState({ isAlertBoxOpen: false });
    };

    const closeQuizAbandon = () => {
      this.setState({ isAlertBoxOpen: false, isQuizBoxOpen: false });
      store.dispatch({ type: CLOSE_QUIZ_ABANDON, payload: this.props.dayId });
    };

    const closeQuizDone = () => {
      this.props.getSurveyStatus();
      this.setState({ isAlertBoxOpen: false, isQuizBoxOpen: false });
      store.dispatch({ type: CLOSE_QUIZ_DONE, payload: this.props.dayId });
    };

    return (
      <Fragment>
        <Button color="secondary" variant="contained" onClick={() => {
          this.setState({ isQuizBoxOpen: true });
          console.log(this.props.dayId)
          store.dispatch({ type: OPEN_QUIZ, payload: this.props.dayId })
        }
        }>
          {this.props.children}
        </Button>
        {/* Pop up of quiz */}
        <Dialog
          fullScreen
          open={this.state.isQuizBoxOpen}
          onClose={closeQuizBox}
        >
          <AppBar style={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={closeQuizBox}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography variant="h6">{this.props.title}</Typography>
            </Toolbar>
          </AppBar>
          {/* Quiz body */}
          {/* Nice to have: Perhaps add a progress bar while iframe is loading? */}
          <div className="iframe-container">
          <iframe
            title="Google Form Iframe"
            src={this.props.href}
            frameBorder="0"
            height="100%"
            width="100%"
          />
          </div>
        </Dialog>

        {/* Alert when user closes the quiz */}
        {/* We want to make sure that the user did not accidentally hit the exit button! :) */}
        <Dialog
          open={this.state.isAlertBoxOpen}
          onClose={closeAlertBox}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to close the quiz?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Any changes made without submitting the form would not be saved.
            </DialogContentText>
            <Alert severity="success">
              I'm done — Select only if you have submitted the form
            </Alert>
            <Alert severity="warning">
              Answer later — Erase your progress and start over later
            </Alert>
            <Alert severity="info">
              Continue working — Close this dialog box and stay on the page
            </Alert>
          </DialogContent>
          <DialogActions>
            <Button onClick={closeQuizDone} variant="outlined" color="primary">
              I'm done
            </Button>
            <Button
              onClick={closeQuizAbandon}
              variant="outlined"
              color="primary"
            >
              Answer later
            </Button>
            <Button onClick={closeAlertBox} variant="contained" color="primary">
              Continue working
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

// TODO: perhaps move all LinkToGoogleFormIframe state to UI (but not needed now)

const mapStateToProps = (state) => ({
});


export default connect(mapStateToProps, { getSurveyStatus })(
  withStyles(styles)(LinkToGoogleFormIframe)
);
